import React, { useState, useEffect } from "react";
import "../../../../../Create_Assessment/Create_Question/Create_Q_Type/createMcq.css";
import AttachUInonEditable from "../../../../../Create_Assessment/Create_Question/Create_Q_Type/AttachUInonEditable";
import ZoomableImage from "../../../../../../../Components/zoomablePic";
export default function McqTypePublisedQuestion(props) {
  return (
    <div className="d-flex align-items-center justify-content-center">
      <div className="col-11 m-0 mt-3 p-3 question_box_container">
        <div className=" d-flex align-items-center">
          <div className="hw_question_no me-2">Q{props.queNo + 1}</div>
          <div className="hw_question_box ">
            {props.title?.split("\n").map((line, index) => (
              <React.Fragment key={index}>
                {index !== 0 && <br />}
                <span>{line}</span>
              </React.Fragment>
            ))}
          </div>
          <div style={{ display: "flex", margin: "10px" }}>
            {props.attachments?.length > 0 &&
              props.attachments.map((attachment, index) => {
                const ext =
                  typeof attachment === "string"
                    ? attachment.split(".").pop().toLowerCase()
                    : "";

                const isImage = ["jpg", "jpeg", "png"].includes(ext);
                return (
                  <div
                    key={index}
                    className="mt-2 hw_default_dropdown_container d-flex"
                  >
                    {isImage ? (
                      <ZoomableImage src={attachment} />
                    ) : (
                      <AttachUInonEditable attachments={attachment} />
                    )}
                  </div>
                );
              })}
          </div>
        </div>
        <div className=" mt-2  d-flex align-items-center hw_default_dropdown_container ">
          <div className="hw_default_dropdown_card">
            <div className="hw_default_dropdown_box_header">CHAPTER</div>
            <span
              className="hw_default_dropdown_box_size"
              style={{
                display: "inline-block",
                maxWidth: "180px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                verticalAlign: "middle",
                cursor: "pointer",
                paddingTop: "8px",
              }}
              title={props.chap}
            >
              {props.chap || "N/A"}
            </span>
          </div>
          <div className="gap-3 time_duration_box d-flex justify-content-between ">
            <div className="hw_default_dropdown_card2">
              <div className="hw_default_dropdown_box_header">MARKS</div>
              <span className="hw_default_dropdown_box_size">
                {props.Correct_Score} Marks
              </span>
            </div>
            <div className="hw_default_dropdown_card2">
              <div className="hw_default_dropdown_box_header">
                LEVEL OF DIFFICULTY
              </div>
              <span className="hw_default_dropdown_box_size">
                {props.difficulty_level}
              </span>
            </div>
          </div>

          {/* <div className="hw_default_dropdown_card ">
            <div className="hw_default_dropdown_box_header">
              KNOWLEDGE DOMAIN
            </div>
            <span className="hw_default_dropdown_box_size">
              {props.knowDom}
            </span>
          </div> */}
          <div className="hw_default_dropdown_card">
            <div className="hw_default_dropdown_box_header">SKILLS</div>
            <span className=" hw_default_dropdown_box_size">
              {props.skills}
            </span>
          </div>

          <div className="hw_default_dropdown_card">
            <div className="hw_default_dropdown_box_header">
              TYPE OF QUESTION
            </div>
            <span className=" hw_default_dropdown_box_size">MCQ Type</span>
          </div>
        </div>
        <div className="mt-2 hw_default_dropdown_container d-flex align-ites-center justify-content-between ">
          <div className="d-flex align-items-center gap-5">
            {/* <div className="hw_mandatory_checkbox ">
              <input type="checkbox" checked={props?.is_mandatory} readOnly />{" "}
              &nbsp;
              <span>Mandatory question</span>
            </div> */}
            <div className="hw_mandatory_checkbox ">
              <input
                type="checkbox"
                checked={props?.addHW === "homework"}
                readOnly
              />{" "}
              &nbsp;
              <span>Add for Assessment</span>
            </div>
          </div>
        </div>

        {props.options.map((obj) => (
          <div className="d-flex mb-3 col-11 mt-3 align-items-start">
            {/* Option Label */}
            <div className="hw_question_no me-2">{obj.key}</div>

            {/* Main Content and Attachment wrapper */}
            <div className="d-flex w-100">
              {/* Option Text */}
              <div className="hw_mcq_option_box flex-grow-1 me-2">
                {obj.value}
              </div>

              {/* Attachment Block (fixed width, even if empty) */}
              <div
                className="hw_default_dropdown_container"
                style={{ width: "100px", minHeight: "60px" }}
              >
                {obj.attachment &&
                  (() => {
                    const ext = obj.attachment?.split(".").pop().toLowerCase();
                    const isImage = ["jpg", "jpeg", "png"].includes(ext);
                    return isImage ? (
                      <ZoomableImage src={obj.attachment} />
                    ) : (
                      <AttachUInonEditable attachments={obj.attachment} />
                    );
                  })()}
              </div>
            </div>
          </div>
        ))}

        <div className=" ml-3 mb-3 col-12 ">
          <div className="hw_select_ans ml-2 mb-2">Correct answer</div>
          <div className="d-flex mb-3 col-12 ml-1 p-0 ">
            <div style={{ width: "100%" }}>
              <div style={{ width: "89.3%" }}>
                {props.correctAns.map((obj) => (
                  <div className="hw_mcq_answer_option_box ">
                    <span className="col-1 px-5 d-flex align-items-center justify-content-center select_option_dropdown   ">
                      {obj.option_key}
                    </span>
                    <div className="col-10 hw_correct_ans_option ">
                      {obj.value}
                    </div>
                  </div>
                ))}
              </div>
              <div className="hw_mandatory_checkbox ml-1 mt-3">
                Add reason for correct answer
              </div>
              <div style={{ width: "96.6%" }}>
                <div style={{ width: "100%", marginTop: "8px" }}>
                  {props.correctAns.map((obj, index) => (
                    <div
                      key={index}
                      className="hw_mcq_option_box"
                      style={{
                        width: "100%",
                        padding: "12px 16px",
                        borderRadius: "8px",
                        border: "1px solid #d0d7de",
                        backgroundColor: "#f9fafb",
                        fontSize: "14px",
                        lineHeight: "1.6",
                        color: "#333",
                        wordBreak: "break-all", // handles long words
                        overflowWrap: "anywhere", // force break if needed
                        whiteSpace: "pre-wrap",
                      }}
                    >
                      {obj.reason_for_answer?.explanation}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
